import { jsx } from 'react/jsx-runtime';
import { useTheme } from 'styled-components';
import { useForTablet } from '@sketch/components';
import BeigeVariant from '@sketch/icons/sidebar-beige.png';
import BeigeVariant2x from '@sketch/icons/sidebar-beige@2x.png';
import GreenVariant from '@sketch/icons/sidebar-green.png';
import GreenVariant2x from '@sketch/icons/sidebar-green@2x.png';
import OrangeVariant from '@sketch/icons/sidebar-orange.png';
import OrangeVariant2x from '@sketch/icons/sidebar-orange@2x.png';
import OrangeDarkVariant from '@sketch/icons/sidebar-orange-dark.png';
import OrangeDarkVariant2x from '@sketch/icons/sidebar-orange-dark@2x.png';
import PurpleVariant from '@sketch/icons/sidebar-purple.png';
import PurpleVariant2x from '@sketch/icons/sidebar-purple@2x.png';
import TealVariant from '@sketch/icons/sidebar-teal.png';
import TealVariant2x from '@sketch/icons/sidebar-teal@2x.png';
import { Image } from './Sidebar.styles.js';

const Sidebar = ({ variant }) => {
    const isTabletAndBigger = useForTablet();
    const theme = useTheme();
    const getVariantImage = () => {
        if (theme._name === 'dark') {
            switch (variant) {
                case 'orange': {
                    return {
                        base: OrangeDarkVariant,
                        size2: OrangeDarkVariant2x,
                    };
                }
                default: {
                    return null;
                }
            }
        }
        switch (variant) {
            case 'beige': {
                return {
                    base: BeigeVariant,
                    size2: BeigeVariant2x,
                };
            }
            case 'green': {
                return {
                    base: GreenVariant,
                    size2: GreenVariant2x,
                };
            }
            case 'purple': {
                return {
                    base: PurpleVariant,
                    size2: PurpleVariant2x,
                };
            }
            case 'teal': {
                return {
                    base: TealVariant,
                    size2: TealVariant2x,
                };
            }
            case 'orange': {
                return {
                    base: OrangeVariant,
                    size2: OrangeVariant2x,
                };
            }
            default: {
                return null;
            }
        }
    };
    const variantImage = getVariantImage();
    if (!variantImage || !isTabletAndBigger)
        return null;
    return (jsx(Image, { alt: `${variant}-image`, src: variantImage.base, srcSet: `${variantImage.size2} 2x` }));
};

export { Sidebar as default };
